import { TaskPriorityOptions } from 'shared/types/task-base';

export enum SortingMode {
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  Custom = 'custom',
  Priority = 'priority',
}

export enum HabitSortingMode {
  Custom = 'custom',
  Priority = 'priority',
}

export enum GoalSortingMode {
  StartDate = 'startDate',
  Deadline = 'deadline',
  Progress = 'progress',
  Custom = 'custom',
}

export enum TodayGroupBy {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
  Type = 'type',
  DayPart = 'dayPart',
}

export enum TagGroupBy {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
  Type = 'type',
}

export enum HabitGroupBy {
  None = 'none',
  Goal = 'goal',
  LifeArea = 'lifeArea',
  Priority = 'priority',
}

export enum GoalGroupBy {
  None = 'none',
  LifeArea = 'lifeArea',
}

export enum OrderDirection {
  Asc = 'ascending',
  Desc = 'descending',
}

export const priorityRanking: Record<TaskPriorityOptions, number> = {
  [TaskPriorityOptions.High]: 0,
  [TaskPriorityOptions.Medium]: 1,
  [TaskPriorityOptions.Low]: 2,
  [TaskPriorityOptions.None]: 3,
};
